/**
 * @file: OutStock.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 业务数据管理中心-食品出库(废弃)
 */
import request from '@/utils/request'

/**
 * 出库详情接口
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function outStockGet(data) {
  return request({
    type: 'biz',
    url: 'out/stock/get',
    method: 'post',
    data
  })
}

/**
 * 扫描条码编号后单件快出、批量出库的商品详细信息（qiuyanping）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function outStockInformationGet(data) {
  return request({
    type: 'biz',
    url: 'out/stock/information/get',
    method: 'post',
    data
  })
}

/**
 * 出库记录列表接口
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function outStockList(data) {
  return request({
    type: 'biz',
    url: 'out/stock/list',
    method: 'post',
    data
  })
}

/**
 * 手动出库详情接口（qiuyanping）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function outStockManualGet(data) {
  return request({
    type: 'biz',
    url: 'out/stock/manual/get',
    method: 'post',
    data
  })
}

/**
 * 手动出库接口（qiuyanping）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function outStockManualList(data) {
  return request({
    type: 'biz',
    url: 'out/stock/manual/list',
    method: 'post',
    data
  })
}

/**
 * 单件快出/批量出库出库操作接口（qiuyanping）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function outStockUpdate(data) {
  return request({
    type: 'biz',
    url: 'out/stock/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/OutStock.js